/**
 * returnUrl is user-controlled (query string). Accept only a same-origin relative path:
 * starts with a single "/", no protocol-relative "//", no backslashes or control characters,
 * no scheme. Anything else is dropped (null).
 */
export const sanitizeReturnUrl = value => {
  if (typeof value !== "string") return null;
  const url = value.trim();
  if (url.length === 0 || url.length > 2048) return null;
  // Check the raw value and up to 3 decoding rounds, so %255C%255C / %2F%2F tricks are caught.
  let current = url;
  for (let round = 0; round <= 3; round += 1) {
    if (current[0] !== "/" || current[1] === "/" || current[1] === "\\") return null;
    // eslint-disable-next-line no-control-regex
    if (/[\u0000-\u001f\u007f\\]/.test(current)) return null;
    let decoded;
    try {
      decoded = decodeURIComponent(current);
    } catch (error) {
      return null;
    }
    if (decoded === current) break;
    current = decoded;
  }
  return url;
};
export const getReturnUrlFromSearch = function () {
  let search = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : typeof window !== "undefined" ? window.location.search : "";
  try {
    return sanitizeReturnUrl(new URLSearchParams(search).get("returnUrl"));
  } catch (error) {
    return null;
  }
};

/** Relative target for a login redirect that must come back to `path`. */
export const buildLoginUrl = (loginPath, returnPath) => {
  const safe = sanitizeReturnUrl(returnPath);
  return safe ? "".concat(loginPath, "?returnUrl=").concat(encodeURIComponent(safe)) : loginPath;
};